import type { ChipProps, SxProps } from "@mui/material";

// eslint-disable-next-line no-restricted-syntax
export enum ShiftChipType {
  MAGIC = "MAGIC",
  URGENT = "URGENT",
  STILL_BOOKABLE = "STILL BOOKABLE",
  ATEAM_EXCLUSIVE_BLOCK = "A-TEAM EXCLUSIVE",
  WORKER_LEFT_EARLY = "WLE",
  WORKER_LEFT_EARLY_REPLACEMENT_WORKER = "WLE RW",
}

export interface ShiftChipAdditionalData {
  priorityTill?: string;
  aTeamData?: {
    windowTill?: string;
    aTeamProfessionals?: string[];
  };
  extendedBookabilityTo?: Date;
  facilityTimeZone?: string;
}

export interface ShiftChip {
  type: ShiftChipType;
  additionalData?: ShiftChipAdditionalData;
  handleClick?: () => void;
}

export interface ShiftChipData {
  type: ShiftChipType;
  color: ChipProps["color"];
  getTooltip: (additionalData?: ShiftChipAdditionalData) => string;
  additionalData?: ShiftChipAdditionalData;
  handleClick?: () => void;
  customStyles?: SxProps;
}
